// PRODUCT PAGE COLLAPSIBLE
function toggleAccordion(element) {
    let content = element.nextElementSibling;
    let caret = element.querySelector(".caret");
  
    content.classList.toggle("active");
    element.classList.toggle("active");
    
    if (content.classList.contains("active")) {
      caret.innerHTML = "-";
    } else {
      caret.innerHTML = "+";
    }
}